/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import PropTypes from "prop-types";
import SubviewController from "./SubviewController";
import t from "../../../trans";
import Navigation from "../../../Navigation";
import UiSchema from "../../../UiSchema";
import JsonSchema from "../../../JsonSchema";
import SchemaRegistry from "../../../services/SchemaRegistry";
import {GotoBackAction} from "../../../services/PageAction";

class SubeditController extends SubviewController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        schema: PropTypes.instanceOf(UiSchema).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    constructor(props, storeMap = null) {
        super(props, storeMap);
        this.state.isLeaving = false;
        this.routerWillLeave = this.routerWillLeave.bind(this);
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
    }

    componentWillUnmount() {
        this.props.router.setRouteLeaveHook(this.props.route, null);
        return super.componentWillUnmount();
    }

    routerWillLeave(nextLocation) {
        if (this.state.isLeaving) return true;
        if (this.state.resource.editRecordIsChanged) return t("You have unsaved modifications. Are you sure you want to leave?");
        return true;
    }

    loadResource() {
        if (this.props && this.props.params && this.props.params.id) {
            super.loadResource();
            if (this.getParentResourceBuffer()) this.actions().editCurrentRecord.defer();
        }
    }

    getParentResourceBuffer(state) {
        if (!state) state = this.state.parentResource;
        return state.editRecord;
    }

    /**
     * Called after user has saved data. Method navigates back to previous page.
     */
    navigateBack() {
        Navigation.gotoBackOrUp();
    }

    /**
     *
     * @param {PageAction} action
     * @returns {boolean}
     */
    onAction(action) {
        switch (action.action) {
            case "subupdate":
                // We are changing subobject. We should save current edit buffer into parent resource's editRecord buffer.
                this.saveToParent("update");
                return true;
                break;

            case "back":
                this.setState({isLeaving: true}, function () {
                    this.navigateBack();
                }.bind(this));
                return true;

        }
        return super.onAction(action);
    }


    saveToParent(action) {
        let newValue = this.applyDataChange(
            this.state.parentResource.editRecord,
            this.props.params.parentField + "/items",
            action,
            this.state.resource.editRecord,
            function (errors) {
                this.actions().setEditErrors({null: errors});
            }.bind(this));
        if (newValue != null) {
            this.actions("parentResource").modifyEditRecord.defer(newValue);
            this.onAction(new GotoBackAction());
        }
    }

    getDataSchema() {
        return new JsonSchema(SchemaRegistry.getJsonSchema(this.props.params.parentResource));
    }
}

export default SubeditController;
